import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { getLogger } from '@confluence/logger';

const logger = getLogger('SmartCreateFeedbackBanner');

// Cap the "seen" list; oldest content IDs are dropped first.
const MAX_SEEN_CONTENT_IDS = 10;

export const STORAGE_KEYS: {
	seen: string;
	slidesSeen: string;
} = {
	seen: PERSISTED_KEYS_ON_SERVER.PERSISTED_SMART_CREATE_FEEDBACK_BANNER_SEEN_CONTENT_IDS,
	slidesSeen:
		PERSISTED_KEYS_ON_SERVER.PERSISTED_SMART_CREATE_FEEDBACK_BANNER_SLIDES_SEEN_CONTENT_IDS,
};

const readSeenContentIds = (storageKey: string): string[] => {
	try {
		const itemString = localStorage.getItem(storageKey);
		if (!itemString) {
			return [];
		}
		const item = JSON.parse(itemString);
		if (Array.isArray(item) && item.every((id) => typeof id === 'string')) {
			return item;
		}
	} catch (error) {
		logger.error`Error parsing local storage key(${storageKey}): ${error}`;
	}
	return [];
};

export const isBannerSeen = (storageKey: string, contentId: string): boolean =>
	readSeenContentIds(storageKey).includes(contentId);

export const markBannerSeen = (storageKey: string, contentId: string): void => {
	const seen = readSeenContentIds(storageKey);
	if (seen.includes(contentId)) {
		return;
	}
	// Cap the list, dropping the oldest entries first.
	const capped = [...seen, contentId].slice(-MAX_SEEN_CONTENT_IDS);
	try {
		localStorage.setItem(storageKey, JSON.stringify(capped));
	} catch (error) {
		logger.error`Error setting local storage key(${storageKey}): ${error}`;
	}
};
